/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RefreshResponseDto } from '../models/RefreshResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReportsService {
    /**
     * @param workspaceId
     * @param reportId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiReports(
        workspaceId?: string,
        reportId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Reports',
            query: {
                'WorkspaceId': workspaceId,
                'ReportId': reportId,
            },
        });
    }
    /**
     * @param workspaceId
     * @param reportId
     * @returns RefreshResponseDto OK
     * @throws ApiError
     */
    public static postApiReportsRefresh(
        workspaceId?: string,
        reportId?: string,
    ): CancelablePromise<RefreshResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Reports/Refresh',
            query: {
                'WorkspaceId': workspaceId,
                'ReportId': reportId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param workspaceId
     * @param reportId
     * @returns RefreshResponseDto OK
     * @throws ApiError
     */
    public static postApiReportsRefreshDelay(
        workspaceId?: string,
        reportId?: string,
    ): CancelablePromise<RefreshResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Reports/RefreshDelay',
            query: {
                'WorkspaceId': workspaceId,
                'ReportId': reportId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
}
